export default "__VITE_ASSET__BHDqdifo__"